










































































import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/whatsapp';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class WhatsappScheduleDialog extends BaseComponent {
  @Prop()
  id: number;

  dialogFlag = false;
  dto = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }
    this.loader.start('Carregando...');
    service.findWhatsappScheduleById(id).subscribe(
      (res) => {
        this.dto = res;
        this.dialogFlag = true;
        this.loader.stop();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
        this.closeForm();
      }
    );
  }

  closeForm() {
    this.$emit('close');
  }
}
